import { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'

import ActionButton from '../../../components/action_button/ActionButton'

const USER_GEOFENCE_MODAL_COLORS = {
  cancelBorder: '#B0A9A4',
  cancelText: '#9D9691',
  cancelHoverBackground: '#FFFFFF',
  cancelDisabledBorder: '#D1CBC7',
  cancelDisabledText: '#BDB6B1',
  confirm: '#50739A',
  confirmDisabledBorder: '#E5E7EB',
  confirmDisabledText: '#A8ACB6',
  confirmDisabledBackground: '#ECEEF2'
}

const MIN_GEOFENCE_DISTANCE = 10
const WARNING_GEOFENCE_DISTANCE = 50
const MAX_GEOFENCE_DISTANCE = 5000

const UserGeofenceModal = ({
  showModal,
  closeModal,
  saving,
  isCustomGeofenceEnabled,
  currentDistance
}) => {
  const [distance, setDistance] = useState('')

  useEffect(() => {
    setDistance(showModal && isCustomGeofenceEnabled ? String(currentDistance || '') : '')
  }, [currentDistance, isCustomGeofenceEnabled, showModal])

  const parsedDistance = Number(distance)
  const isDistanceValid =
    Number.isInteger(parsedDistance) &&
    parsedDistance >= MIN_GEOFENCE_DISTANCE &&
    parsedDistance <= MAX_GEOFENCE_DISTANCE

  const handleConfirm = () => {
    closeModal(true, parsedDistance)
  }

  const handleCancel = () => {
    if (!saving) {
      closeModal(false)
    }
  }

  const handleDistanceChange = (event) => {
    const value = event.target.value

    if (/^\d{0,4}$/.test(value)) {
      setDistance(value)
    }
  }

  return (
    <Modal
      onHide={handleCancel}
      backdrop="static"
      keyboard={false}
      show={showModal}
      centered
      dialogClassName="user-geofence-modal-dialog"
      contentClassName="user-geofence-modal-content"
    >
      <Modal.Header className="user-geofence-modal-header">
        <Modal.Title className="user-geofence-modal-title">
          Modificar geocerca personalizada
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="user-geofence-modal-body">
        <p className="user-geofence-modal-description">
          Define el radio de geocerca para este usuario. Este valor sobrescribira el predeterminado
          del sistema y aplicara a partir de hoy.
        </p>

        <div className="user-geofence-modal-hint">
          <span className="material-symbols-outlined user-geofence-modal-icon-filled">info</span>
          <span>Rango valido: 10 m - 5000 m</span>
        </div>

        {parsedDistance > 0 && parsedDistance < WARNING_GEOFENCE_DISTANCE && (
          <div className="user-geofence-modal-warning">
            <span className="material-symbols-outlined">warning</span>
            <span>
              Asignar un radio menor a 50 m puede reducir la precision en la validacion de visitas.
            </span>
          </div>
        )}

        <div className="user-geofence-modal-field">
          <label htmlFor="geo_max_distance_in_meter" className="user-geofence-modal-label">
            Radio personalizado
          </label>
          <div className="user-geofence-input-group">
            <input
              type="number"
              id="geo_max_distance_in_meter"
              onChange={handleDistanceChange}
              className="form-control"
              required
              value={distance}
              placeholder="Ej. 100"
              min={MIN_GEOFENCE_DISTANCE}
              max={MAX_GEOFENCE_DISTANCE}
              step="1"
            />
            <span>metros</span>
          </div>
          {distance !== '' && !isDistanceValid && (
            <p className="ft-12 mt-10 color-error">Ingresa un valor entero entre 10 m y 5000 m.</p>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer className="user-geofence-modal-footer">
        <ActionButton
          onClick={handleCancel}
          text="Cancelar"
          variant="outlined"
          color={USER_GEOFENCE_MODAL_COLORS.cancelBorder}
          textColor={USER_GEOFENCE_MODAL_COLORS.cancelText}
          disabled={saving}
          sx={{
            minWidth: 80,
            height: 30,
            borderRadius: 1.25,
            fontSize: 14,
            fontWeight: 500,
            '&:hover': {
              backgroundColor: USER_GEOFENCE_MODAL_COLORS.cancelHoverBackground,
              borderColor: USER_GEOFENCE_MODAL_COLORS.cancelBorder,
              color: USER_GEOFENCE_MODAL_COLORS.cancelText
            },
            '&.Mui-disabled': {
              borderColor: USER_GEOFENCE_MODAL_COLORS.cancelDisabledBorder,
              color: USER_GEOFENCE_MODAL_COLORS.cancelDisabledText,
              backgroundColor: USER_GEOFENCE_MODAL_COLORS.cancelHoverBackground
            }
          }}
        />
        <ActionButton
          onClick={handleConfirm}
          text="Guardar"
          color={USER_GEOFENCE_MODAL_COLORS.confirm}
          disabled={saving || !isDistanceValid}
          sx={{
            minWidth: 100,
            height: 30,
            borderRadius: 1.25,
            fontSize: 14,
            fontWeight: 500,
            '&.Mui-disabled': {
              borderColor: USER_GEOFENCE_MODAL_COLORS.confirmDisabledBorder,
              color: USER_GEOFENCE_MODAL_COLORS.confirmDisabledText,
              backgroundColor: USER_GEOFENCE_MODAL_COLORS.confirmDisabledBackground
            }
          }}
        />
      </Modal.Footer>
    </Modal>
  )
}

export default UserGeofenceModal
